import { NotificationManager } from 'react-notifications';
import { getActiveClassrooms } from '../services/classroom';
import { getAllStudents } from '../services/students';
import { setClassrooms, setStudents } from '../redux/actions';
import store from '../redux/store';

export const notify = (type, message, timeOut, onClick) => {
  NotificationManager.remove({ id: 1 });

  setTimeout(() => {
    NotificationManager.create({
      id: 1,
      type: type,
      message: message,
      title: '',
      timeOut: timeOut,
      onClick: onClick
    });
  }, 450);
};

export const refreshClassrooms = async (teacherId) => {
  const classrooms = await getActiveClassrooms(teacherId);
  store.dispatch(setClassrooms(classrooms));
  return classrooms;
};

export const refreshStudents = async (teacherId) => {
  const students = await getAllStudents(teacherId);
  store.dispatch(setStudents(students));
  return students;
};
